import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './ProductPrepMemberships.css';
export default function PrepDialog({ title, children, onClose, busy = false, alert = false }) {
  const ref = useRef(null);
  useEffect(() => {
    const before = document.activeElement, overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden'; ref.current?.focus();
    return () => { document.body.style.overflow = overflow; before?.focus?.(); };
  }, []);
  return createPortal(<div className="product-prep-overlay"><section className="product-prep-dialog" role={alert ? 'alertdialog' : 'dialog'} aria-modal="true" aria-label={title} tabIndex={-1} ref={ref} onKeyDown={event => {
    if (event.key === 'Escape' && !busy) { event.preventDefault(); onClose(); }
    if (event.key !== 'Tab') return;
    const controls = [...ref.current.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),a[href]')];
    const first = controls[0], last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && [first, ref.current].includes(document.activeElement)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }}><header><h2>{title}</h2><button type="button" onClick={onClose} disabled={busy} aria-label="關閉備播設定">×</button></header>{children}</section></div>, document.body);
}
